// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"455":"13f6ac40","977":"80607c3c"}[chunkId] + ".chunk.js";
};